<template>
    <div class="content_box">
        <div class="content">
            <div class="title">
                <span>SKU-人员配置</span><br><br>
            </div>
            <div class="search_box">
                <div class="platform"><span>销售渠道</span>&nbsp;&nbsp;
                    <el-radio-group v-model="platform" size="small">
                        <el-radio-button class="radio" :label="item.code" v-for="(item, i) in selectData.platform_list"
                            :key="i">{{ item.desc }}</el-radio-button>
                    </el-radio-group>
                </div>
                <el-form :inline="true" class="demo-form-inline search-form form-list" label-width="90px">
                    <el-form-item>
                        <el-select v-model="searchData.mate_id" clearable :popper-append-to-body="false" filterable
                            placeholder="负责人">
                            <el-option :label="item.mate_name" :value="item.id"
                                v-for="(item, i) in selectData.mate_list" :key="item + i"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.LXSid" clearable :popper-append-to-body="false" filterable
                            placeholder="销售店铺">
                            <el-option :label="item.seller_name" :value="item.LXSid"
                                v-for="(item, i) in selectData.seller_list" :key="item + i"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.status" :popper-append-to-body="false" placeholder="配对状态">
                            <el-option :label="item.desc" :value="item.status" v-for="item in selectData.status_res"
                                :key="item.status + '123'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.sku" placeholder="平台SKU" :popper-append-to-body="false" class="longer"
                            filterable clearable>
                            <el-option :label="item.sku" :value="item.sku" v-for="(item, i) in selectData.sku_list"
                                :key="i + '321'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.asin" clearable :popper-append-to-body="false" filterable
                            placeholder="ASIN">
                            <el-option :label="item.asin" :value="item.asin" v-for="(item, i) in selectData.ASIN_list"
                                :key="item + i"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.c_sku" clearable :popper-append-to-body="false" filterable class="longer"
                            placeholder="供应链SKU">
                            <el-option :label="item.c_sku" :value="item.c_sku" v-for="(item, i) in selectData.csku_list"
                                :key="i + '123'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form_item date_picker" label="配对时间">
                        <DatePicker :date="createTime" :clearable="true" @dateSelect="dateSelect"></DatePicker>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                        <div class="button search white" @click="init">
                            <span>重置</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-table :data="skuList" highlight-current-row :fit="true" style="width:100%">
                <el-table-column prop="mate_id" label="负责人" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.mate_id && scope.row.mate_id != 0 ? scope.row.mate_id : '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="LXSid" label="销售店铺" width="120">
                </el-table-column>
                <el-table-column prop="sku" label="平台SKU" min-width="200" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="asin" label="ASIN" width="120">
                    <template slot-scope="scope">
                        <span>{{ scope.row.asin || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="c_sku" label="供应链SKU" min-width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.c_sku || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="productName" label="供应链SKU品名" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.productName || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="start_date" label="负责开始时间" width="150">
                    <template slot-scope="scope">
                        <span>{{ scope.row.start_date && scope.row.start_date != '2006-01-01' ? scope.row.start_date :
                                '--'
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="update_time" label="配对时间" width="150">
                    <template slot-scope="scope">
                        <span>{{ formDate(scope.row.update_time, 'YYYY-MM-DD') || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="配对状态" width="100" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="status1" v-if="scope.row.status == 0">未配对</span>
                        <span class="status2" v-if="scope.row.status == 1">已配对</span>
                    </template>
                </el-table-column>
                <el-table-column prop="act" label="操作" width="200">
                    <template slot-scope="scope">
                        <div class="btn">
                            <div v-if="scope.row.status == 0">
                                <div class="button text" @click="openDialog('pair', '配对', scope.row)"
                                    v-if="roleCheck('102-100-105-102')">
                                    <span>配对</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="button text" @click="openDialog('editPair', '修改配对', scope.row)"
                                    v-if="roleCheck('102-100-105-102')">
                                    <span>修改配对</span>
                                </div>
                                <div class="button text" @click="openDialog('pairLog', '配对记录', scope.row)">
                                    <span>配对记录</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
            <Gh-Dialog ref="dislog" size="big" :title="dislog.title" @dialogBack="dislogAct">
                <template v-slot:content>
                    <el-form label-width="150px" :model="pairData" ref="formRule" :rules="formRule">
                        <template v-if="dislog.type == 'pair' || dislog.type == 'editPair'">
                            <el-form-item label="销售店铺：">
                                {{ pairData.LXSid }}
                            </el-form-item>
                            <el-form-item label="平台sku：">
                                {{ pairData.sku }}
                            </el-form-item>
                            <el-form-item label="ASIN：">
                                {{ pairData.asin }}
                            </el-form-item>
                            <el-form-item label="供应链SKU：" prop="c_sku">
                                <el-select v-model="pairData.c_sku" clearable placeholder="请选择" filterable>
                                    <el-option :label="item.c_sku" :value="item.c_sku"
                                        v-for="(item, i) in selectData.csku_list" :key="i + '123'"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="负责人：" prop="mate_id">
                                <el-select v-model="pairData.mate_id" clearable placeholder="请选择" @change="mateChange">
                                    <el-option :label="item.mate_name" :value="item.id"
                                        v-for="(item, i) in selectData.mate_list" :key="item + i"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="负责开始时间：" prop="start_date">
                                <el-date-picker v-model="pairData.start_date" type="date" value-format="yyyy-MM-dd"
                                    :editable="true" placeholder="选择日期" :picker-options="pickerOptions()">
                                </el-date-picker>
                            </el-form-item>
                        </template>
                        <template v-else>
                            <el-form :model="pairLog" label-position="left" label-width="100px">
                                <div v-for="(item, index) in pairLog" class="log">
                                    <el-form-item label="配对时间：">
                                        <span>{{ formDate(item.update_time) || '--' }}</span>
                                    </el-form-item>
                                    <el-form-item label="操作人：">
                                        <span>{{ item.op_name || '--' }}</span>
                                    </el-form-item>
                                    <el-form-item label="负责人：">
                                        <span>{{ item.mate_id && item.mate_id != 0 ? item.mate_id : '--' }}</span>
                                    </el-form-item>
                                    <el-form-item label="负责周期：">
                                        <span v-if="new Date(item.start_date).getTime() > new Date().getTime()">
                                            {{item.start_date}}~{{item.end_date && item.end_date !='2999-01-01' ? item.end_date : ''}}
                                        </span>
                                        <span v-else>{{ item.start_date && item.start_date !=
                                                '2006-01-01' ? item.start_date : '初始时间'}}
                                                ~{{ item.end_date && item.end_date !='2999-01-01' ? item.end_date : '至今'}}
                                        </span>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </template>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>

export default ({
    name: 'sales-detail',
    data() {
        return {
            createTime: [],
            searchData: {
                platform: 'aws',
                asin: '',
                mate_id: '',
                sku: '',
                LXSid: '',
                status: -1,
                c_sku: '',
                start_date: '',
                end_date: '',
                page_size: 10,
                page: 1,
            },
            total: 0,
            skuList: [],
            selectData: {  //真实显示数据
                platform_list: [],
                team_list: [],
                mate_list: [],
                seller_list: [],
                country_list: [],
                status_res: [],
                product_type_list: [],
                ASIN_list: []
            },
            country_list: [],
            dislog: {},
            pairData: {
                platform: '',
                LXSid: '',
                sku: '',
                asin: '',
                c_sku: '',
                mate_id: '',
                start_date: '',
            },
            formRule: {
                c_sku: [this.requiredRule('请选择供应链sku')],
                mate_id: [this.requiredRule('请选择负责人')],
                start_date: [this.requiredRule('请选择负责开始日期')]
            },
            pairLog: [],
            platform: 'aws',
            pairDate:''
        }
    },
    watch: {
        createTime: function (nTime) {
            if (nTime && nTime.length > 1) {
                this.searchData.start_date = this.formDate(nTime[0], 'YYYY-MM-DD');
                this.searchData.end_date = this.formDate(nTime[1], 'YYYY-MM-DD');
            } else {
                this.searchData.start_date = '';
                this.searchData.end_date = '';
            }
        },
        'platform': function (n) {
            this.searchData.platform = n;
            this.getSkuList();
        }
    },
    created() {
        this.getSkuParamList();
        this.search();
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getSkuList();
        },
        init() {
            this.searchData.platform = 'aws';
            this.searchData.sku = '';
            this.searchData.c_sku = '';
            this.searchData.LXSid = '';
            this.searchData.asin = '';
            this.searchData.status = -1;
            this.searchData.mate_id = '';
            this.searchData.page_size = 10;
            this.searchData.page = 1;
            this.searchData.start_date = '',
                this.createTime = []
        },
        dateSelect(date) {
            this.createTime = date ? [...date] : '';
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getSkuList();
        },
        getSkuParamList() {
            this.api.getSkuParamList().then(data => {
                this.selectData.platform_list = data.data.platform_list;
                this.selectData.mate_list = data.data.mate_list;
                this.selectData.seller_list = data.data.seller_list;
                this.selectData.sku_list = data.data.sku_list;
                this.selectData.csku_list = data.data.csku_list;
                this.selectData.ASIN_list = data.data.sku_list;
                this.selectData.status_res = data.data.status_res;
            })
        },
        getSkuList() {
            this.api.getSkuList(this.searchData).then(data => {
                if (data.data) {
                    if (data.data.list) {
                        var list = data.data.list;
                        var that = this;
                        list.forEach(function (item, index, arr) {
                            that.selectData.mate_list.forEach(mate_list => {
                                if (mate_list.id == item.mate_id) {
                                    arr[index].mate_id = mate_list.mate_name;
                                    return;
                                }
                            });
                            that.selectData.seller_list.forEach(seller_list => {
                                if (seller_list.LXSid == item.LXSid) {
                                    arr[index].LXSid = seller_list.seller_name;
                                    return;
                                }
                            });
                        });
                        this.skuList = list;
                        this.total = data.data.total;
                    } else {
                        this.skuList = [];
                        this.total = 0;
                    }
                } else {
                    this.skuList = [];
                    this.total = 0;
                }

            })
        },
        openDialog(type, title, row) {
            this.pairDate = '';
            this.pairData = {
                platform: '',
                LXSid: '',
                sku: '',
                asin: '',
                c_sku: '',
                mate_id: '',
                start_date: '',
            };
            this.dislog = {
                type: type,
                title: title,
                show: true,
            };
            if (type == 'pair' || type == 'editPair') {
                this.pairData.platform = this.searchData.platform;
                this.pairData.LXSid = row.LXSid;
                this.pairData.sku = row.sku;
                this.pairData.asin = row.asin;
                this.pairData.c_sku = row.c_sku;
                this.pairData.mate_id = row.mate_id && row.mate_id != 0 ? row.mate_id : '';
                this.selectData.mate_list.forEach(mate_list => {
                    if (mate_list.mate_name == this.pairData.mate_id) {
                        this.pairData.mate_id = mate_list.id;
                        return;
                    }
                });
                this.pairData.start_date = row.start_date && row.start_date != '2006-01-01' ? row.start_date : '';
                this.pairDate = this.pairData.start_date;
                this.$refs.dislog.show = true;
            } else if (type == 'pairLog') {
                var req = {
                    platform: this.searchData.platform,
                    LXSid: '',
                    sku: row.sku,
                    asin: row.asin
                };
                this.selectData.seller_list.forEach(seller_list => {
                    if (seller_list.seller_name == row.LXSid) {
                        req.LXSid = seller_list.LXSid;
                        return;
                    }
                });
                this.api.getSkuPairLog(req).then(data => {
                    var list = data.data || [];
                    var that = this;
                    list.forEach(function (item, index, arr) {
                        that.selectData.mate_list.forEach(mate_list => {
                            if (mate_list.id == item.mate_id) {
                                arr[index].mate_id = mate_list.mate_name;
                                return;
                            }
                        });
                    });
                    this.pairLog = list;
                    this.$refs.dislog.show = true;
                })
            }
        },
        dislogAct() {
            this.$refs.formRule.validate(v => {
                if (v) {
                    if (this.dislog.type == 'pair' || this.dislog.type == 'editPair') {
                        var pairList = { ...this.pairData };
                        this.selectData.seller_list.forEach(seller_list => {
                            if (seller_list.seller_name == pairList.LXSid) {
                                pairList.LXSid = seller_list.LXSid;
                                return;
                            }
                        });

                        if (this.dislog.type == 'pair') {
                            pairList.status = 0;
                        } else {
                            pairList.status = 1;
                        }
                        this.api.dealSkuPair(pairList).then(data => {
                            this.$message.success('操作成功！');
                            this.getSkuList();
                            this.$refs.dislog.show = false;
                            this.dislog.show = false;
                        })
                        return
                    }
                }
            });

        },
        mateChange() {
            this.pairData.start_date = '';
        },
        pickerOptions() {
            var _this = this
            return {
                disabledDate(time) {
                    return time.getTime() > new Date().getTime()  ||  time.getTime() < new Date(_this.pairDate).getTime();
                }
            }
        },
    }
})
</script>
<style lang="less" scoped>
.content {
    padding: 20px;
    background-color: @colorWhite;

    .status2 {
        color: #00D6B9;
    }

    .platform {
        color: #999999;
        font-size: 14px;
        padding-bottom: 25px;

        .radio {
            padding-right: 20px;
        }

        /deep/.el-radio-button__inner {
            border-radius: 4px;
            border: 1px solid #507FF7;
            width: 100px;

        }

        /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
            background-color: #507FF7;
        }
    }

    .log {
        border-bottom: 1px solid #E8E9F1;
        padding-bottom: 30px;

        /deep/ .el-form-item {
            margin-bottom: 0;
        }
    }

    .log:nth-of-type(n+2) {
        padding-top: 30px;
    }

    .log:last-child {
        border-bottom: none;
    }
    .longer{
        /deep/ .el-select-dropdown{
            min-width: 300px !important;
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/view/statistics/sales/sku-manage.vue